export const TOGGLE_FULLSCREEN = 'toggle fullscreen';
export const ENTER_FULLSCREEN = 'enter fullscreen';
export const LEAVE_FULLSCREEN = 'leave fullscreen';

/* istanbul ignore next */
export function toggleFullscreen(){
    return  {
        type : TOGGLE_FULLSCREEN
    };
}

/* istanbul ignore next */
export function enterFullscreen(){
    return  {
        type : ENTER_FULLSCREEN
    };
}

/* istanbul ignore next */
export function leaveFullscreen(){
    return  {
        type : LEAVE_FULLSCREEN
    };
}



// WEBPACK FOOTER //
// ./src/actions/ui.action.js